import React from 'react';
import { useResourceContext } from '../../../contexts/ResourceContext';
import { motion, AnimatePresence } from 'framer-motion';
import ExpandedResource from '../../Resources/ExpandedResource';
import '../../../Styles/Expanded.css';
import '../../../Styles/Resources.css';
import { useChatContext } from '../../../contexts/AppDataContext';
import type { SubmitEvent } from '../../Chat/hooks/useMessageSubmission';

interface ResourcesPanelProps {
  setInput: (input: string) => void;
  triggerSubmit: (e?: SubmitEvent | React.FormEvent) => void;
}

const StudyPanel: React.FC<ResourcesPanelProps> = ({ setInput, triggerSubmit }) => {
  const { isResourcesVisible } = useResourceContext();
  const { setQuotedContent } = useChatContext();

  const handleSelectionAction = (quotedText: string, text: string) => {
    setQuotedContent(quotedText);
    setInput(text);
    const payload: SubmitEvent = {
      preventDefault: () => {},
      overrideInput: text,
      overrideQuotedContent: quotedText,
    };
    triggerSubmit(payload);
  };


  return (
    <AnimatePresence initial={false} mode="sync">
      {isResourcesVisible && (
        <motion.div
          key="study-panel"
          className={`resources-section`}
          initial={{ x: '100%', opacity: 0.7 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: '100%', opacity: 0.7 }}
          transition={{ duration: 0.42, ease: [0.23, 1, 0.32, 1] }}
          style={{ willChange: 'transform, opacity' }}
        >
            <ExpandedResource
              onSelectionAction={handleSelectionAction}
            />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default React.memo(StudyPanel);
